import { notification } from 'antd';

/**
 * CommonNotification - A centralized notification service for the application
 * Provides wrapper functions for Ant Design's notification system
 */

// Configure default notification settings
notification.config({
  placement: 'topRight',
  duration: 4, // 4 seconds
  maxCount: 3, // Maximum number of notifications shown at once
});

/**
 * Display a success notification
 * @param {string} message - The notification message
 * @param {string} description - Optional description text
 * @param {number} duration - Optional duration in seconds (default: 4)
 */
export const showSuccess = (message, description = '', duration = 4) => {
  notification.success({
    message,
    description,
    duration,
  });
};

/**
 * Display an error notification
 * @param {string} message - The notification message
 * @param {string} description - Optional description text
 * @param {number} duration - Optional duration in seconds (default: 4)
 */
export const showError = (message, description = '', duration = 4) => {
  notification.error({
    message,
    description,
    duration,
  });
};

/**
 * Display a warning notification
 * @param {string} message - The notification message
 * @param {string} description - Optional description text
 * @param {number} duration - Optional duration in seconds (default: 4)
 */
export const showWarning = (message, description = '', duration = 4) => {
  notification.warning({
    message,
    description,
    duration,
  });
};

/**
 * Display an info notification
 * @param {string} message - The notification message
 * @param {string} description - Optional description text
 * @param {number} duration - Optional duration in seconds (default: 4)
 */
export const showInfo = (message, description = '', duration = 4) => {
  notification.info({
    message,
    description,
    duration,
  });
};

/**
 * Close all notifications currently open
 */
export const closeAll = () => {
  notification.destroy();
};

const CommonNotification = {
  success: showSuccess,
  error: showError,
  warning: showWarning,
  info: showInfo,
  closeAll,
};

export default CommonNotification;
